import { render, staticRenderFns } from "./KpiCardWidget.vue?vue&type=template&id=4b5f7493&scoped=true"
import script from "./KpiCardWidget.vue?vue&type=script&lang=js"
export * from "./KpiCardWidget.vue?vue&type=script&lang=js"
import style0 from "./KpiCardWidget.vue?vue&type=style&index=0&id=4b5f7493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f7493",
  null
  
)

export default component.exports